import { render, staticRenderFns } from "./activityinfo.vue?vue&type=template&id=eddffd80&scoped=true"
import script from "./activityinfo.vue?vue&type=script&lang=js"
export * from "./activityinfo.vue?vue&type=script&lang=js"
import style0 from "./activityinfo.vue?vue&type=style&index=0&id=eddffd80&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eddffd80",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\workspace\\ysorder\\order_admin_client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('eddffd80')) {
      api.createRecord('eddffd80', component.options)
    } else {
      api.reload('eddffd80', component.options)
    }
    module.hot.accept("./activityinfo.vue?vue&type=template&id=eddffd80&scoped=true", function () {
      api.rerender('eddffd80', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/marketing/activity/activityinfo.vue"
export default component.exports